module.exports = __webpack_public_path__ + "img/location.398ee4b6.png";